import { ResponseBodyValidationError } from '../errors/ResponseBodyValidationError';

export const isResponseBodyValidationError = (
  error: unknown,
): error is ResponseBodyValidationError => {
  if (error instanceof ResponseBodyValidationError) {
    return true;
  }

  if (error instanceof Error) {
    if (error.name === 'ResponseBodyValidationError') {
      return true;
    }
  }

  return false;
};
